/**
 * Escapes special regex characters in a string to make it safe for use in regex patterns.
 * This prevents ReDoS (Regular Expression Denial of Service) attacks by treating
 * user input as literal text rather than regex patterns.
 *
 * @param input - The string to escape
 * @returns The escaped string safe for use in regex patterns
 *
 * @example
 * escapeRegex("test[123]") // returns "test\\[123\\]"
 * escapeRegex("user.name") // returns "user\\.name"
 */
export const escapeRegex = (input: string): string => {
	if (!input) return input;

	// Escape all regex special characters: \ ^ $ . | ? * + ( ) [ ] { }
	return input.replace(/[\\^$.*+?()[\]{}|]/g, "\\$&");
};
